/*!
 * jQuery iframe dynamic height - v1.0 - 2016-04-29
 *
 * Copyright (c) 2016 Sterzinger Web Solutions
 * https://sterzinger.solutions
 */

(function ( $ ) {

	$.fn.iframedynheight = function( options ) {

		// standard settings
		var settings = $.extend({
			domain: 'localhost'
		}, options );

		return this.each(function() {
			$(this).load(function(){
				document.domain = settings.domain;
				var iframe = this;
				var content = $(this).contents().find('body');
				content.resize(function(){
					var elem = $(this);
					$(iframe).css({ height: elem.outerHeight( true ) });
					console.log('iframe height: ' + elem.outerHeight( true ));
					console.log(document.domain);
				});
				content.resize();
			});
		});

	};

	// $.fn.iframedynheight.publicfn = function() {

	// };

}( jQuery ));
